import { Box } from '@mui/system'

const DOT_SIZE = 10
const SEGMENT_WIDTH = 80
const SEGMENT_HEIGHT = 2

/**
 * Two-step progress (email → password / SSO). Second segment is “complete” on the password step.
 */
const LoginStepIndicator = ({ activeIndex }) => (
  <Box sx={styles.row} aria-hidden>
    <Box
      sx={[styles.dot, activeIndex >= 0 ? styles.dotActive : styles.dotInactive]}
    />
    <Box
      sx={[
        styles.segment,
        activeIndex >= 1 ? styles.segmentActive : styles.segmentInactive,
      ]}
    />
    <Box
      sx={[styles.dot, activeIndex >= 1 ? styles.dotActive : styles.dotInactive]}
    />
  </Box>
)

const styles = {
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    mb: { xs: 2, sm: 2.5 },
  },
  dot: {
    width: DOT_SIZE,
    height: DOT_SIZE,
    borderRadius: '50%',
    flexShrink: 0,
  },
  dotActive: {
    bgcolor: 'primary.main',
  },
  dotInactive: {
    bgcolor: 'grey.300',
  },
  segment: {
    width: SEGMENT_WIDTH,
    height: SEGMENT_HEIGHT,
    borderRadius: 1,
  },
  segmentActive: {
    bgcolor: 'primary.main',
  },
  segmentInactive: {
    bgcolor: 'grey.300',
  },
}

export default LoginStepIndicator
